/*
 * ScreenSwiper
 * @module components
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';
import { Redirect } from 'react-router-dom';

export type MyWealthRootProps = {
  children: React$Node,
  location: Location,
  redirect?: string,
  swiperRef: React$ElementRef<*>,
};

const SwiperWrapper = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

/**
 * ScreenSwiper React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {React.Children} [props.children] - children
 * @param {Location} [props.location] - location
 * @param {string} [props.redirect] - redirect
 * @param {React$ElementRef<*>} [props.swiperRef] - swiper element reference
 * @example <caption>Simple usage</caption>
 * <ScreenSwiper screens={[]}/>
 * @returns {React.Node<*>} React-component
 */
export const ScreenSwiper = ({
  children,
  location,
  redirect,
  swiperRef,
}: MyWealthRootProps) => (
  <SwiperWrapper ref={swiperRef} testid="screen-swiper">
    {redirect && redirect !== location.pathname ? (
      <Redirect to={redirect} />
    ) : (
      children
    )}
  </SwiperWrapper>
);
